export function openPublicFile(file: string, extension = '') {
  const fileUrl = `${process.env.PUBLIC_URL}${file}${extension}`;

  if (!fileUrl) {
    return;
  }

  window.open(fileUrl);
}
